import React from 'react';
import Layout from '../../components/Layout/Layout';
import styles from './BlogPost.module.css';
const BlogPost = ({ post }) => {
    if (!post) {
        return (React.createElement(Layout, { currentPath: "/blog" },
            React.createElement("div", { className: styles.notFound },
                React.createElement("h1", null, "Post Not Found"),
                React.createElement("p", null,
                    React.createElement("a", { href: "/blog" }, "\u2190 Back to blog")))));
    }
    const currentPath = post.slug ? `/blog/${post.slug}` : '/blog';
    return (React.createElement(Layout, { currentPath: currentPath },
        React.createElement("article", { className: styles.blogPost },
            React.createElement("header", { className: styles.postHeader },
                React.createElement("div", { className: styles.headerContent },
                    React.createElement("a", { href: "/blog", className: styles.backLink }, "\u2190 Back to blog"),
                    React.createElement("h1", null, post.title),
                    React.createElement("div", { className: styles.postMeta },
                        React.createElement("time", null, new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })),
                        React.createElement("span", { className: styles.separator }, "\u2022"),
                        React.createElement("span", null, post.readTime),
                        React.createElement("span", { className: styles.separator }, "\u2022"),
                        React.createElement("span", null,
                            "By ",
                            post.author)),
                    post.tags && post.tags.length > 0 && (React.createElement("div", { className: styles.tags }, post.tags.map((tag) => (React.createElement("span", { key: tag, className: styles.tag }, tag))))))),
            React.createElement("div", { className: styles.postContent },
                React.createElement("div", { className: styles.prose, dangerouslySetInnerHTML: { __html: post.content } })),
            React.createElement("footer", { className: styles.postFooter },
                React.createElement("div", { className: styles.footerContent },
                    React.createElement("p", { className: styles.cta },
                        "Have thoughts on this? ",
                        React.createElement("a", { href: "/contact" }, "Let's discuss your specific challenges"),
                        "."),
                    React.createElement("a", { href: "/blog", className: styles.backLink }, "\u2190 Back to all posts"))))));
};
export default BlogPost;
